import * as _ from '../vendor/lodash'
import { h } from 'preact'

export default function route (path, view, props) {
  return h(view, _.extend({}, props, {
    path: `/app${path ? '/' + path : ''}`
  }))
}
